$(document).ready(() => {

  $("#hamburguesa").click(function(e) {
    e.preventDefault();
    $("#wrapper").toggleClass("toggled");
  });



});
